import React, { useState } from 'react';
import './PBMServices.css';
import logo from '../logos/pbm-Logo.png';

const PBM = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="pbm-container">
            <img src={logo} alt="pbm Logo" className="pbm-logo" />
            <h1 className="pbm-title">PBM Services</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=d1301890-68ba-49af-bc52-7502994157f5&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="pbm-box">
                <div className="pbm-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="pbm-faq-section">
                <h2 className="pbm-faq-title">Frequently Asked Questions</h2>
                <div className="pbm-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`pbm-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="pbm-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="pbm-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`pbm-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PBM;